import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const min2Files = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    return (control.value && control.value.length > 1) ? null : { minFiles: true }
  };
};
